import {
  applyMemberDayExceptions,
  getEffectiveBookableWindows,
  hhmmToMinutes,
  type ClinicHoursExceptionType,
  type ClinicHoursSource,
  type ClinicianDayHours,
  type HourPeriod,
  type MemberDayException,
} from './clinicHours';

export type { MemberDayException, MemberExceptionType } from './clinicHours';

export function practitionerWeeklyPeriods(
  clinicianDay: ClinicianDayHours | null | undefined,
): HourPeriod[] {
  if (!clinicianDay?.enabled || !clinicianDay.start || !clinicianDay.end) return [];
  return [{ start: clinicianDay.start, end: clinicianDay.end }];
}

export function applyMemberExceptions(
  weeklyPeriods: HourPeriod[],
  exceptions: readonly MemberDayException[],
): HourPeriod[] {
  return applyMemberDayExceptions(weeklyPeriods, exceptions);
}

export function unionPeriods(windows: HourPeriod[][]): HourPeriod[] {
  const flat = windows.flat().map((period) => ({ start: period.start, end: period.end }));
  flat.sort((a, b) => hhmmToMinutes(a.start) - hhmmToMinutes(b.start));
  const merged: HourPeriod[] = [];
  for (const period of flat) {
    const last = merged[merged.length - 1];
    if (!last || hhmmToMinutes(period.start) > hhmmToMinutes(last.end)) {
      merged.push({ ...period });
      continue;
    }
    if (hhmmToMinutes(period.end) > hhmmToMinutes(last.end)) last.end = period.end;
  }
  return merged;
}

export function practitionerDateHoursKey(practitionerId: string, isoDate: string): string {
  return `${practitionerId}:${isoDate}`;
}

export function resolvePractitionerDayWindows(input: {
  clinicPeriods: HourPeriod[] | null | undefined;
  clinicSource?: ClinicHoursSource;
  clinicExceptionType?: ClinicHoursExceptionType | null;
  clinicianDay?: ClinicianDayHours | null;
  memberExceptions?: readonly MemberDayException[] | null;
}): HourPeriod[] {
  return getEffectiveBookableWindows({
    clinicPeriods: input.clinicPeriods,
    clinicSource: input.clinicSource ?? 'weekly',
    clinicExceptionType: input.clinicExceptionType,
    clinicianDay: input.clinicianDay,
    memberExceptions: input.memberExceptions,
  });
}
